module.exports = __webpack_public_path__ + "img/footer-cg.2e0194cb.png";